import React from "react";

// Import the images from your assets folder
import aboutImage from '../assets/image/about1.jpg';  // Adjust the path if needed
import IntegrityImage from '../assets/image/Integrity.png'; // Adjust the path if needed
import ExcellenceImage from '../assets/image/Excellence.jpg'; // Adjust the path if needed
import InnovationImage from '../assets/image/Innovation.png'; // Adjust the path if needed

const AboutPage = () => (
  <div
    style={{
      fontFamily: "Arial, sans-serif",
      color: "#333",
      lineHeight: "1.6",
      padding: "20px",
      backgroundColor: "#f4f4f4",
    }}
  >
    {/* Hero Section */}
    <section
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "40px",
        backgroundColor: "#007bff",
        borderRadius: "10px",
        color: "white",
        marginBottom: "40px",
      }}
    >
      <div style={{ flex: 1, paddingRight: "20px" }}>
        <h1 style={{ fontSize: "36px", marginBottom: "20px" }}>About Atlas Trade Center</h1>
        <p style={{ fontSize: "18px" }}>
          Atlas Trade Center, a proud Sri Lankan establishment, is a leader in providing innovative trade solutions
          tailored for businesses across the island. Rooted in the cultural heritage and entrepreneurial spirit of Sri
          Lanka, we are committed to empowering local industries with world-class products and services that drive growth
          and success.
          <br />
          <br />
          Our story begins with a passion for excellence and a vision to uplift the Sri Lankan business landscape. From
          bustling city centers to the tranquil rural villages, Atlas Trade Center has been a trusted partner in
          addressing the diverse needs of our clientele. Our offerings span a wide array of industries, ensuring that
          every business, big or small, finds the support it needs to thrive.
          <br />
          <br />
          <br />
        </p>
      </div>
      {/* Replace this with your local image */}
      <img
        src={aboutImage}  // Use the imported image
        alt="Atlas Trade Center"
        style={{
          width: "500px",
          height: "350px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      />
    </section>

    {/* Our Mission and Vision Section */}
    <section
      style={{
        marginBottom: "50px",
        padding: "40px",
        backgroundColor: "#f9f9f9",
        borderRadius: "15px",
        boxShadow: "0 10px 20px rgba(0, 0, 0, 0.1)",
        textAlign: "center",
        border: "1px solid #ddd",
      }}
    >
      {/* Our Mission */}
      <h2
        style={{
          fontSize: "36px",
          marginBottom: "20px",
          color: "#333",
          fontWeight: "bold",
          textTransform: "uppercase",
          letterSpacing: "2px",
        }}
      >
        Our Mission
      </h2>
      <p
        style={{
          fontSize: "18px",
          color: "#555",
          lineHeight: "1.8",
          marginBottom: "40px",
          maxWidth: "800px",
          margin: "0 auto",
          fontStyle: "italic",
        }}
      >
        Our mission is to provide businesses with the best products and services that cater to their specific needs. We
        aim to be a reliable partner by offering high-quality solutions, personalized customer service, and innovative
        strategies to help businesses succeed. Together, we build pathways for growth and success.
      </p>

      {/* Divider */}
      <div
        style={{
          height: "3px",
          width: "60px",
          backgroundColor: "#007bff",
          margin: "0 auto 40px auto",
          borderRadius: "5px",
        }}
      ></div>

      {/* Our Vision */}
      <h2
        style={{
          fontSize: "36px",
          marginBottom: "20px",
          color: "#333",
          fontWeight: "bold",
          textTransform: "uppercase",
          letterSpacing: "2px",
        }}
      >
        Our Vision
      </h2>
      <p
        style={{
          fontSize: "18px",
          color: "#555",
          lineHeight: "1.8",
          marginBottom: "40px",
          maxWidth: "800px",
          margin: "0 auto",
          fontStyle: "italic",
        }}
      >
        Our vision is to be a driving force in the Sri Lankan business landscape, empowering local industries to achieve
        global standards while fostering sustainable growth and prosperity for our nation. We aim to create a legacy of
        success through innovation, trust, and excellence.
      </p>
    </section>

    {/* Core Values Section */}
    <section
      style={{
        display: "flex",
        gap: "20px",
        marginBottom: "40px",
        flexWrap: "wrap",
      }}
    >
      <div
        style={{
          flex: "1",
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "20px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
        }}
      >
        <img
          src={IntegrityImage}
          alt="Integrity"
          style={{
            marginBottom: "1px",
            width: "100px",  // Set a fixed width for uniformity
            height: "100px", // Set a fixed height to maintain aspect ratio
            objectFit: "cover", // Ensure the image is contained within the box without distortion
            borderRadius: "50%", // Make the image circular (optional)
          }}
        />
        <h3 style={{ marginBottom: "10px", color: "#007bff" }}>Integrity</h3>
        <p>We value honesty and transparency in all our dealings.</p>
      </div>

      <div
        style={{
          flex: "1",
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "20px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
        }}
      >
        <img
          src={ExcellenceImage}
          alt="Excellence"
          style={{
            marginBottom: "10px",
            width: "100px",  // Set a fixed width for uniformity
            height: "100px", // Set a fixed height to maintain aspect ratio
            objectFit: "cover", // Ensure the image is contained within the box without distortion
            borderRadius: "50%", // Make the image circular (optional)
          }}
        />
        <h3 style={{ marginBottom: "10px", color: "#007bff" }}>Excellence</h3>
        <p>We strive to exceed expectations in everything we do.</p>
      </div>

      <div
        style={{
          flex: "1",
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "20px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
        }}
      >
        <img
          src={InnovationImage}
          alt="Innovation"
          style={{
            marginBottom: "10px",
            width: "100px",  // Set a fixed width for uniformity
            height: "100px", // Set a fixed height to maintain aspect ratio
            objectFit: "cover", // Ensure the image is contained within the box without distortion
            borderRadius: "50%", // Make the image circular (optional)
          }}
        />
        <h3 style={{ marginBottom: "10px", color: "#007bff" }}>Innovation</h3>
        <p>We embrace new ideas and technologies to stay ahead.</p>
      </div>
    </section>

    {/* Contact Section */}
    <section
      style={{
        textAlign: "center",
        padding: "40px",
        backgroundColor: "#007bff",
        color: "white",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      }}
    >
      <h2 style={{ fontSize: "28px", marginBottom: "15px" }}>Contact Us</h2>
      <p style={{ fontSize: "16px", marginBottom: "20px" }}>
        Have questions or want to learn more about our products and services? Get in touch with us today!
      </p>
      <a
        href="/contact"
        style={{
          padding: "10px 30px",
          backgroundColor: "#fff",
          color: "#007bff",
          textDecoration: "none",
          borderRadius: "5px",
          fontSize: "16px",
          fontWeight: "bold",
          transition: "background-color 0.3s ease",
        }}
        onMouseEnter={(e) => (e.target.style.backgroundColor = "#0056b3")}
        onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
      >
        Get in Touch
      </a>
    </section>
  </div>
);

export default AboutPage;
